<template>
  <v-container fluid class="monitorSite px-4">
    <div class="align-left">Report Summary Page</div>
    <h1>{{ this.reportTitle }}</h1>

    <!-- <textarea style="border:solid 1px;padding:10px;min-width:800px;min-height:150px" id="csvResult">Press the "Show export text" button to view exported CSV here</textarea> -->

    <div flex-nowrap class="float-right">
      <!-- <v-btn v-on:click="onBtnUpdate()">Show export text</v-btn> -->
      <v-btn class="button" color="secondary" v-on:click="onBtnExport()">Export to file</v-btn>
    </div>

    <div flex-nowrap class="float-left">
      <v-btn class="button" color="primary" v-on:click="sizeColumnsToFit()">Fit to Page</v-btn>
      <v-btn class="button" color="primary" v-on:click="autoSizeColumns(true)">Auto-Fit Data</v-btn>
      <v-btn class="button" color="primary" v-on:click="autoSizeColumns(false)">Auto-Fit All</v-btn>
    </div>

    <div style="clear: both;"></div>

    <div class="grid">
      <ag-grid-vue
        id="myGrid"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham center-box elevation-2"
        :columnDefs="columnDefs"
        :rowData="rowData"
        @rowDoubleClicked="onRowDoubleClicked"
        :gridOptions="gridOptions"
      ></ag-grid-vue>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { AgGridVue } from "ag-grid-vue";
import router from "@/router";
import { adminService } from "@/services/adminService.js";
// import { utilityService } from "@/services/utilityService.js";

export default {
  name: "Report100M",
  data: () => ({
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    reportId: null,
    volumeId: null,
    reportTitle: "100 Million Dollar Differences Summary: ",
    columnDefs: [],
    rowData: [],
    chartData: [],
    reportHeaders: [
      { headerName: "Agency Code", field: "agencyCode", width: 150, textAlign: "text-left" },
      { headerName: "Agency Name", field: "agencyName", width: 600, textAlign: "text-left" },
      { headerName: "Submit Date", field: "submitDate", width: 125, textAlign: "text-right" },
      { headerName: "No. of Differences", field: "numDifferences", width: 150, textAlign: "text-right" }
    ]
  }),
  components: {
    AgGridVue
  },
  created () {
    this.reportId = this.$route.params.reportId;
  },
  beforeMount () {
    this.gridOptions = {};
  },
  mounted () {
    let me = this;

    me.gridApi = me.gridOptions.api;
    me.gridColumnApi = me.gridOptions.columnApi;

    me.volumeId = 71; // GBC Pull from configuration
    me.reportTitle += ' Volume ' + me.volumeId;

    for (var i = 0; i < me.reportHeaders.length; i++) {
      var tmpColumnDef = {};
      tmpColumnDef.headerName = me.reportHeaders[i].headerName;
      tmpColumnDef.field = me.reportHeaders[i].field;
      tmpColumnDef.width = me.reportHeaders[i].width;
      tmpColumnDef.sortable = true;
      tmpColumnDef.filter = true;
      tmpColumnDef.resizable = true;
      tmpColumnDef.cellClass = me.reportHeaders[i].textAlign;
      // tmpColumnDef.valueFormatter = me.reportFields[i].format;
      me.columnDefs.push(tmpColumnDef);
    }

    adminService
      .getReportDetails(me.volumeId)
      .then(function (resp) {
        me.rowData = resp.data;
        console.log("me.rowData = " + JSON.stringify(me.rowData));
        for (var i = 0; i < me.rowData.length; i++) {
          me.rowData[i].submitDate = me.convertDateTime(me.rowData[i].submitDate);
          me.rowData[i].agencyCode = me.rowData[i].agencyCode + String.fromCharCode(8203);
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  },
  methods: {
    convertDateTime (date) {
      var tmpDate = new Date(date);
      var year = tmpDate.getFullYear();
      var month = tmpDate.getMonth() + 1;
      var day = tmpDate.getDate();
      var hour = tmpDate.getHours();
      var minute = tmpDate.getMinutes();
      var timeSuffix = '';

      if (day.toString().length == 1) {
        day = '0' + day;
      }
      if (hour >= 12) {
        timeSuffix = 'PM';
      } else {
        timeSuffix = 'AM';
      }
      if (hour === 0) {
        hour = 12;
      }
      if (hour >= 13) {
        hour -= 12;
      }
      if (hour <= 9) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      // return month + '/' + day + '/' + year + '  ' + hour + ':' + minute + ' ' + timeSuffix;
      return month + '/' + day + '/' + year;
    },
    onRowDoubleClicked (evt) {
      const selectedRowData = evt.data;
      // console.log('selectedRowData = ' + JSON.stringify(selectedRowData));
      if (selectedRowData) {
        router.push({
          name: "admin.report100mdetail",
          params: {
            // reportId: this.reportId,
            officeId: selectedRowData.officeId,
            agencyName: selectedRowData.agencyName,
            volumeId: this.volumeId
          }
        });
      }
    },
    sizeColumnsToFit () {
      this.gridApi.sizeColumnsToFit();
    },
    autoSizeColumns (header) {
      var tmpColumns = [];
      for (var i = 0; i < this.reportHeaders.length; i++) {
        tmpColumns.push(this.reportHeaders[i].field);
      }
      this.gridColumnApi.autoSizeColumns(tmpColumns, header);
    },
    onBtnExport () {
      var params = this.getParams();
      if (params.suppressQuotes || params.columnSeparator) {
        alert(
          'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
        );
      }
      this.gridApi.exportDataAsCsv(params);
    },
    onBtnUpdate () {
      document.querySelector('#csvResult').value = this.gridApi.getDataAsCsv(
        this.getParams()
      );
    },
    getParams () {
      return {
        suppressQuotes: false,
        columnSeparator: false,
        customHeader: [
            [
              { data: { value: ' ', type: 'String' } },
              { data: { value: '100 Million Dollar Differences Summary: ', type: 'String' } },
              { data: { value: 'Volume ' + this.volumeId, type: 'String' } }
            ],
            []
        ],
        customFooter: [],
        fileName: "100MDiffRptSum"
      };
    },
    onGridReady (params) {}
  }
};

</script>

<style scoped>
.align-left {
  text-align: left;
}
.float-left {
	float: left;
}
.float-right {
	float: right;
}
.button {
  max-height: 25px;
  margin: 10px 10px 10px 0px;
}
h1 {
  margin: 0px 0 20px 0;
}
.text-color {
  color: #14427d;
}
.grid {
  width: 100%;
  height: 70vh;
  border: 1px solid
}
</style>
